import { jsx as i } from "react/jsx-runtime";
import { createContext as c, useState as l, useEffect as E, useContext as d } from "react";
import { getEmulationCookieSC as x, getEmulationCookieProxy as g } from "../utils/emulation/index.js";
const n = c(void 0), p = ({ children: t }) => {
  const [e, o] = l({ isEmulating: !1 });
  return E(() => {
    const { isScEmulation: r, agentId: a } = x(), { isProxyEmulation: s, actorId: u, actorName: m } = g();
    if (r)
      return o({
        isEmulating: !0,
        actorId: void 0,
        actorName: void 0,
        agentId: a
      });
    if (s)
      return o({
        isEmulating: !0,
        actorId: u,
        actorName: m,
        agentId: void 0
      });
  }, []), /* @__PURE__ */ i(
    n.Provider,
    {
      value: {
        emulation: e,
        setEmulation: o
      },
      children: e.isEmulating ? /* @__PURE__ */ i("div", { style: { border: "4px solid #c86932", minHeight: "100vh" }, children: t }) : t
    }
  );
}, I = () => d(n);
export {
  n as E,
  p as a,
  I as u
};
